export function getDisconnects ({ state, commit }, page = 1) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/disconnects', { params: { page: page } })
      .then((response) => {
        if (response.data.disconnects) {
          commit('setDisconnects', response.data.disconnects)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getDisconnect ({ state, commit }, disconnectId) {
  return new Promise((resolve, reject) => {
    if (disconnectId) {
      axiosInstance.get('/v1/disconnects/' + disconnectId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No disconnect id'))
    }
  })
}

export function getCreateDisconnect ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/disconnects/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createDisconnect ({ state, commit }, { ip, clientKEY, motiv }) {
  return new Promise((resolve, reject) => {
    const params = ip.length > 0 ? { ip, motiv } : { clientKEY, motiv }
    axiosInstance.post('/v1/disconnects', params)
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditDisconnect ({ state, commit }, disconnectId) {
  return new Promise((resolve, reject) => {
    if (disconnectId) {
      axiosInstance.get('/v1/disconnects/' + disconnectId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No disconnect id'))
    }
  })
}

/* eslint-disable-next-line */
export function editDisconnect ({ state, commit }, { id, description, procent }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/disconnects/' + id, { description, procent })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No disconnect id'))
    }
  })
}

export function deleteDisconnect ({ state, commit }, disconnectId) {
  return new Promise((resolve, reject) => {
    if (disconnectId) {
      axiosInstance.delete('/v1/disconnects/' + disconnectId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No disconnect id'))
    }
  })
}

export function switchBan ({ state, commit }, disconnectId) {
  return new Promise((resolve, reject) => {
    if (disconnectId) {
      axiosInstance.patch('/v1/disconnects/' + disconnectId + '/switch')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No disconnect id'))
    }
  })
}
